const rootPath = '/svg';

const svgFiles = {
  genericUser: `${rootPath}/generic-user.svg`,
  calendarGray: `${rootPath}/calendarGray.svg`,
};

export default svgFiles;
